import type { Channel, Playlist, CanvasLayout } from './types'

export const PREVIEW_READY = 'preview-ready' as const
export const PREVIEW_DATA = 'preview-data' as const
export const PREVIEW_CONFIG = 'preview-config' as const

export type PreviewContentType = 'channel' | 'playlist' | 'canvasLayout'

export interface PreviewReadyMessage {
  type: typeof PREVIEW_READY
}

export interface PreviewDataMessage {
  type: typeof PREVIEW_DATA
  contentType: PreviewContentType
  data: Channel | Playlist | CanvasLayout
}

export interface PreviewConfigMessage {
  type: typeof PREVIEW_CONFIG
  aspectRatio?: string
  background?: string
}

export type PreviewMessage = PreviewReadyMessage | PreviewDataMessage | PreviewConfigMessage
